import requests from "./httpService";

const CashBookReportServices = {
  getCategoryWiseReport: async ({
    fromDate,
    toDate,
    passbookId
  }) => {
    const params = new URLSearchParams({
      fromDate,
      toDate,
      passbookId
    });

    return requests.get(
      `/cash-book-reports/category-wise?${params.toString()}`
    );
  }
};

export default CashBookReportServices;